import {
  SUPPORTED_FEATURES,
  YOUTUBE_PLAYER_PARAMETERS,
} from './video-constants';
import { VideoProps } from './video-model';
import styles from './video.module.scss';

export const Video: React.FC<VideoProps> = ({ sectionId, title, url }) => {
  const allow = SUPPORTED_FEATURES.join(';');
  const src = `${url}?${YOUTUBE_PLAYER_PARAMETERS.join('&')}`;

  return (
    <div className={styles.video} id={sectionId} tabIndex={0}>
      <iframe
        allow={allow}
        src={src}
        title={`video ${title}`}
        loading="lazy"
      ></iframe>
    </div>
  );
};
